import React, { useState } from 'react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo funciona el acceso?',
    a: 'Después de comprar, recibirás un email instantáneamente con los links de descarga. El ebook está en PDF, los bonos en Google Sheets editables, y el video en MP4. Todo listo para usar en 5 minutos.'
  }, {
    q: '¿Es para principiantes?',
    a: '100%. Está diseñado para alguien que NUNCA hizo Meta Ads. Todo paso a paso. Si ya tienes experiencia, los bonos avanzados te van a acelerar 6 meses de learning.'
  }, {
    q: '¿Cuánto dinero necesito para empezar?',
    a: 'Mínimo $75.000-150.000 ARS para hacer testing. Pero el ebook te enseña cómo empezar incluso con menos y ganar de forma inteligente antes de escalar.'
  }, {
    q: '¿Funcionan estos métodos en 2026?',
    a: 'Sí. El ebook fue actualizado en 2026 con los cambios actuales de Meta Ads, MercadoPago y el mercado argentino. Nada de técnicas viejas. Todo actual.'
  }, {
    q: '¿Hay garantía realmente?',
    a: '100% real. Si en 30 días no vale lo que pagaste, escribís un email y devolvemos toda la plata. Sin preguntas. Confiamos en lo que entregamos.'
  }, {
    q: '¿Cuánto puedo ganar realmente?',
    a: 'Depende de cuánto dediques y qué producto escijas. Pero está documentado que con $75.000-150.000 ARS iniciales, se puede llegar a $750.000-1.500.000 ARS/mes en 3 meses si ejecutás bien. Algunos llegan a $7.500.000+. El límite es tuyo.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <section className="py-20 px-4" data-id="element-21">
      <div className="max-w-[900px] mx-auto" data-id="element-22">
        <h2 className="text-3xl md:text-[2.5rem] font-bold text-[#00d4ff] text-center mb-12 uppercase" data-id="element-23">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="flex flex-col gap-5" data-id="element-24">
          {faqs.map((faq, idx) => {
          const isOpen = openIdx === idx;
          return <div key={idx} className="bg-[#00d4ff]/5 border-2 border-[#00d4ff]/20 rounded-xl p-5 md:p-6 cursor-pointer transition-colors hover:bg-[#00d4ff]/10" onClick={() => setOpenIdx(isOpen ? null : idx)} data-id="element-25">
                <div className="flex justify-between items-center gap-4" data-id="element-26">
                  <h3 className="text-[1.1rem] font-bold text-[#00d4ff]" data-id="element-27">
                    {faq.q}
                  </h3>
                  <span className="text-2xl text-[#00d4ff] font-light leading-none" data-id="element-28">
                    {isOpen ? '−' : '+'}
                  </span>
                </div>

                {isOpen && <div className="mt-4 text-[#e0e0e0] leading-relaxed text-[0.95rem] animate-fade-in-up" style={{
              animationDuration: '0.3s'
            }} data-id="element-29">
                    {faq.a}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}